import Config from "./global/Config"
import $ from "jquery"
import SimpleBar from "simplebar"
import { isMobileDevice, getInternetExplorerVersion } from "./utils/helper"
import Accessibility from "./utils/Accessibility"
import AnchorLink from "./utils/AnchorLink"
import GeneralHelper from "./utils/GeneralHelper"
import "./utils/typo3-SpamProtectedEmails.js"

import DynamicModuleLoader from "./global/DynamicModuleLoader"
import DynamicExternalModuleLoader from "./global/DynamicExternalModuleLoader"

class Main {
	constructor() {
		this.setGlobalVars()
		this.setWebpackPublicPath()
		this._init()
	}

	_init() {
		document.addEventListener("scroll", () => {
			document.body.classList.toggle("bb-page-is-scrolled", window.scrollY > 1)
		})
		$(document.body).removeClass("no-js")

		if (isMobileDevice()) {
			$(document.body).addClass("is-mobile")
		}

		if (getInternetExplorerVersion() === 11) {
			$(document.body).addClass("is-ie-11")
		}

		// check if webp images ara supportet, if not show fallback (for IE11 and Safari)
		var webP = new Image()
		webP.onload = webP.onerror = () => {
			if (webP.height !== 2) {
				$(document)
					.find("img[data-srcfallback]")
					.each(function () {
						$(this)
							.attr("src", $(this).attr("data-srcfallback"))
							.attr("srcset", $(this).attr("data-srcsetfallback"))
					})
			}
		}
		webP.src =
			"data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA"

		// check if objectFit is supportet, if not show use fallback
		if ("objectFit" in document.documentElement.style === false) {
			$(".bb-image.needs-object-fit-fallback").each((index, elem) => {
				const $image = $(elem).find("img")

				$image.on("load", () => {
					elem.style.backgroundImage =
						'url("' + ($image[0].currentSrc || $image[0].src).replace(/"/g, '\\"') + '")'
					$(elem).addClass("show-object-fit-fallback")
				})
			})
		}

		//some forms were lazy loaded, make sure that form component is loaded in this case
		$("body").on("bb-form-items-changed", () => {
			DynamicModuleLoader.load($("form").length, DynamicModuleLoader.modules.formComponent)
		})

		// set timeout for storybook
		if (isDev) {
			window.setTimeout(() => {
				this.dynamicLoad()

				document.dispatchEvent(new Event("BB_Main_Loaded"))
			}, 400)
		} else {
			this.dynamicLoad()

			document.dispatchEvent(new Event("BB_Main_Loaded"))
		}
	}

	dynamicLoad() {
		// wait for storybook timeout
		$("table.no-borders").parent().addClass("no-borders")
		this._addTableScrollbar()

		DynamicModuleLoader.load($(".repeatable-container").length, DynamicModuleLoader.modules.formRepeatable)
		DynamicModuleLoader.load(Config.debug, DynamicModuleLoader.modules.versionDisplay)
		DynamicModuleLoader.load($("[data-fancybox]").length, DynamicModuleLoader.modules.lightboxComponent)
		DynamicModuleLoader.load($("form").length, DynamicModuleLoader.modules.formComponent)
		DynamicModuleLoader.load(
			$("[data-repeatable-container][data-is-root]").length,
			DynamicModuleLoader.modules.formRepeatable,
		)
		DynamicModuleLoader.load($(".bb-accordion").length, DynamicModuleLoader.modules.accordionComponent)
		DynamicModuleLoader.load($(".bb-header").length, DynamicModuleLoader.modules.headerComponent)
		DynamicModuleLoader.load($(".bb-hamburger").length, DynamicModuleLoader.modules.hamburgerComponent)
		DynamicModuleLoader.load($(".bb-language-overlay").length, DynamicModuleLoader.modules.languageOverlay)
		DynamicModuleLoader.load(
			$(".bb-language-switcher").length,
			DynamicModuleLoader.modules.languageSwitcherComponent,
		)
		DynamicModuleLoader.load($(".bb-map").length, DynamicModuleLoader.modules.mapComponent)
		DynamicModuleLoader.load(
			$(".bb-mealprepset-detail").length,
			DynamicModuleLoader.modules.mealprepsetDetailComponent,
		)
		DynamicModuleLoader.load($(".bb-news-list").length, DynamicModuleLoader.modules.newsListComponent)
		DynamicModuleLoader.load($(".bb-overlay").length, DynamicModuleLoader.modules.overlayComponent)
		DynamicModuleLoader.load(
			$(".bb-header-image-with-video").length,
			DynamicModuleLoader.modules.headerImageWithVideoComponent,
		)
		DynamicModuleLoader.load($(".bb-header-teaser").length, DynamicModuleLoader.modules.headerTeaserComponent)
		DynamicModuleLoader.load($(".bb-search").length, DynamicModuleLoader.modules.searchComponent)
		DynamicModuleLoader.load($(".bb-search-input__form").length, DynamicModuleLoader.modules.searchInputComponent)
		DynamicModuleLoader.load($(".bb-slider-container").length, DynamicModuleLoader.modules.sliderContainerComponent)
		DynamicModuleLoader.load($(".bb-tabs").length, DynamicModuleLoader.modules.tabsComponent)
		DynamicModuleLoader.load($(".bb-table-accordion").length, DynamicModuleLoader.modules.tableAccordionComponent)
		DynamicModuleLoader.load($(".bb-tooltip").length, DynamicModuleLoader.modules.tooltipComponent)
		DynamicModuleLoader.load(
			$(".bb-youtube-video").length,
			DynamicModuleLoader.modules.youtubeVideoComponent,
			(youtubeVideoComponent) => {
				this.youtubeVideoComponent = youtubeVideoComponent
			},
		)
		DynamicModuleLoader.load(
			$(".bb-vimeo-video").length,
			DynamicModuleLoader.modules.vimeoVideoComponent,
			(vimeoVideoComponent) => {
				this.vimeoVideoComponent = vimeoVideoComponent
			},
		)
		// DynamicModuleLoader.load($(".bb-job-search").length, DynamicModuleLoader.modules.jobSearchComponent)
		// DynamicModuleLoader.load($(".bb-contact-persons").length, DynamicModuleLoader.modules.contactPersonsComponent)
		// DynamicModuleLoader.load($(".bb-medienportal").length, DynamicModuleLoader.modules.medienportalComponent)
		DynamicModuleLoader.load(
			$(".bb-teaser-newsletter").length,
			DynamicModuleLoader.modules.teaserNewsletterComponent,
		)
		DynamicModuleLoader.load(
			$(".bb-newsletter-overlay").length,
			DynamicModuleLoader.modules.newsletterOverlayComponent,
		)
		DynamicModuleLoader.load($(".bb-sort-dropdown").length, DynamicModuleLoader.modules.sortDropdownComponent)
		DynamicModuleLoader.load($(".bb-sticky-banner").length, DynamicModuleLoader.modules.stickyBannerComponent)
		DynamicModuleLoader.load($(".bb-sticky-sub-navigation").length, DynamicModuleLoader.modules.stickySubNavigationComponent)
		DynamicModuleLoader.load(
			$(".bb-feedback").length,
			DynamicModuleLoader.modules.feedbackComponent,
			(FeedbackComp) => {
				document.querySelectorAll(".bb-feedback").forEach((item) => {
					new FeedbackComp(item)
				})
			},
		)
		DynamicModuleLoader.load(
			$(".bb-filter-dropdown").length,
			DynamicModuleLoader.modules.recipesFilterDropdownComponent,
		)
		DynamicModuleLoader.load($(".bb-recipes-filter").length, DynamicModuleLoader.modules.recipesFilterComponent)
		DynamicModuleLoader.load(
			$(".bb-recipes-filter-overlay").length,
			DynamicModuleLoader.modules.recipesFilterOverlayComponent,
		)
		DynamicModuleLoader.load($(".bb-products-category").length, DynamicModuleLoader.modules.productsCategoryComponent)
		DynamicModuleLoader.load($(".bb-products-index").length, DynamicModuleLoader.modules.productsIndexComponent)
		DynamicModuleLoader.load($(".bb-products-slider").length, DynamicModuleLoader.modules.productsSliderComponent)
		DynamicModuleLoader.load($(".bb-product-detail").length, DynamicModuleLoader.modules.productDetailComponent)
		DynamicModuleLoader.load($(".bb-teaser-product").length, DynamicModuleLoader.modules.teaserProductComponent)
		DynamicModuleLoader.load(
			$(".bb-teaser-tile--has-slider").length,
			DynamicModuleLoader.modules.teaserTileComponent,
		)
		DynamicModuleLoader.load(
			$(".bb-teaser-recipe-search").length,
			DynamicModuleLoader.modules.teaserRecipeSearchComponent,
		)
		DynamicModuleLoader.load($(".bb-hscontent").length, DynamicModuleLoader.modules.HSContentComponent)
		DynamicModuleLoader.load(
			$(".bb-ingredients-calculator").length,
			DynamicModuleLoader.modules.ingredientsCalculatorComponent,
		)
		DynamicModuleLoader.load(
			$(".bb-ignite-video").length,
			DynamicModuleLoader.modules.igniteVideoComponent,
		)
		DynamicModuleLoader.load($(".bb-cookmode").length, DynamicModuleLoader.modules.cookmodeComponent)
		DynamicModuleLoader.load($(".bb-recipe-detail").length, DynamicModuleLoader.modules.recipeDetailComponent)
		DynamicModuleLoader.load(
			$(".bb-recipe-collection-header").length,
			DynamicModuleLoader.modules.recipeCollectionHeaderComponent,
		)
		DynamicModuleLoader.load($(".bb-news-detail").length, DynamicModuleLoader.modules.newsDetailComponent)
		DynamicModuleLoader.load($(".bb-content-slider").length, DynamicModuleLoader.modules.contentSliderComponent)
		DynamicModuleLoader.load($(".bb-review").length, DynamicModuleLoader.modules.reviewComponent)
		DynamicModuleLoader.load($(".bb-teaser-list").length, DynamicModuleLoader.modules.teaserListComponent)
		DynamicModuleLoader.load($(".bb-teaser").length, DynamicModuleLoader.modules.teaserComponent)
		DynamicModuleLoader.load(
			$(".bb-auto-complete-input").length,
			DynamicModuleLoader.modules.autoCompleteInputComponent,
		)

		Config.module.external.forEach((item) => {
			DynamicExternalModuleLoader.load($(item.selector).length, item.js, item.css)
		})
	}

	/**
	 * set variable in window scope
	 */
	setGlobalVars() {
		window.$ = window.jQuery = $
		window.DynamicModuleLoader = DynamicModuleLoader
	}

	/**
	 * Change webpacks publicPath on the fly
	 */
	setWebpackPublicPath() {
		if (Config.publicPath) {
			__webpack_public_path__ = Config.publicPath
		}
	}

	/**
	 * Google Maps Callback:
	 * initMap() from Maps2 Extension
	 * hide Controls
	 */
	initMap() {
		window.initMap()
		$("form.txMaps2Form").hide()
	}

	/**
	 * set css-class for scrollbar visibility
	 */
	_addTableScrollbar() {
		$(document)
			.find(".table-responsive")
			.each((i, table) => {
				new SimpleBar(table, { autoHide: false })
			})
	}
}

$(() => {
	window.bbMain = new Main()
})

$(window).on("load", () => {
	window.setTimeout(() => {
		new Accessibility()
		new AnchorLink()
		new GeneralHelper()
	}, 10)
})

if (window.location.hash) {
	window.scroll(0, 0)
}
